import { __zcFin, __zcFinZ, __zcMkv, __zcPs } from "__zod-compiler-runtime__";
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'

/**
 * This schema verifies the payload received by the React application
 * has a known shape. The content inside "contentfulRawJsonResponse" should
 * be later validated by other schemas.
 */
export const PayloadSchema = /* @__PURE__ */ (() => {
var __zs=z.lazy(() =>
  z.object({
    contentfulRawJsonResponse: z.looseObject({}),
    userLoggedIn: z.boolean().optional(),
    additionalProps: safeOptional(z.object({page: z.number(), totalPages: z.number()})),
  }),
);
var __rf=[__zs._zod.innerType.shape["additionalProps"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __bf_2={};
var __rfn_8=__rf[0];
function __vb_11(input){var __bv_3,__bs_4,__bv_5,__bv_6,__bx_7,__bw_9,__bo_10;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_2;__bv_3=input["contentfulRawJsonResponse"];if(!(typeof __bv_3==="object"&&__bv_3!==null&&!Array.isArray(__bv_3)))return __bf_2;__bs_4=__zcPs(__bv_3);__bv_5=input["userLoggedIn"];if(!((__bv_5===undefined||(typeof __bv_5==="boolean"))))return __bf_2;__bv_6=input["additionalProps"];if(__bv_6===undefined){__bw_9=undefined;}else{__bx_7=__rfn_8(__bv_6);__bw_9=__bx_7;}__bo_10={"contentfulRawJsonResponse":__bs_4};if(__bv_5!==undefined||("userLoggedIn" in input)){__bo_10["userLoggedIn"]=__bv_5;}if(__bw_9!==undefined||("additionalProps" in input)){__bo_10["additionalProps"]=__bw_9;}return __bo_10;}
var __rfm_z=__zs.safeParse;
function safeParse_PayloadSchema(input){
var __bd_12=__vb_11(input);
if(__bd_12!==__bf_2){return{success:true,data:__bd_12};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_PayloadSchema,__zs,null,null);
})()

export type Payload = z.infer<typeof PayloadSchema>

export function toPayload(payload: unknown): Payload {
  return PayloadSchema.parse(payload)
}
